import React from "react";
import CustomSection from "../../Components/Common/CustomSection";
import {termsData} from "./TermsData"


const TermsOfServices = () => {
  return (
    <div className="bg-gray-50 min-h-screen px-[120px] py-8 mt-16">
      <div className="bg-white shadow-lg rounded-lg max-w-7xl mx-auto overflow-hidden">
        <div className="relative">
          <img
            src="https://previews.123rf.com/images/vectoro/vectoro2102/vectoro210200016/164663071-doctors-explain-health-conditions-to-female-patients-at-medical-check-up-flat-cartoon-vector.jpg"
            alt="Terms and condition"
            className="w-full h-72 object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <h1 className="text-3xl md:text-4xl font-bold text-slate-200">
              Terms of Service
            </h1>
          </div>
        </div>
        <div className="p-8">
          <h2 className="text-2xl font-semibold mb-6 text-slate-600">
            Your Rights, Your Responsibilities: Understanding Our Healthcare
            Platform Terms.
          </h2>

          {termsData.map((section, index) => (
            <CustomSection key={index} title={section.title}>
              {section.content}
            </CustomSection>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TermsOfServices;
